import "./styles/app.css";
import "./vendor";
import { initRouter } from "./router";
import { bindGlobalEvents } from "./event-bindings";
import { initStrategies } from "./pages/strategies";
import { initAuth } from "./pages/auth";
import { bootstrapApp } from "./bootstrap";

initRouter();
bindGlobalEvents();
initStrategies();
initAuth();
bootstrapApp();

console.log("sveta frontend initialized");
